import PageTitle from "../../components/pagetitle/PageTitle";
import Bg from "../../images/shapes/shape_title_under_line.svg";
import shape1 from "../../images/shapes/shape_space_4.svg";
import shape2 from "../../images/shapes/shape_angle_3.webp";
function Privacypolicy() {
  const bgg = {
    backgroundColor: "#F9F9F9",
    padding: "2rem",
    borderRadius: "10px",
    marginTop: "2rem",
  };

  return (
    <main className="page_content about-page">
      <PageTitle pageTitle="Privacy & Policy" />

      <section className="faq_section section_decoration pt-5">
        <div className="container">
          <div className="heading_block text-center">
            <div
              className="heading_focus_text has_underline d-inline-flex"
              style={{ backgroundImage: `url(${Bg})` }}
            >
              Privacy Policy
            </div>
          </div>

          <p className="mt-4 lh-base text-start">
            At Ape It Solutions, we are committed to protecting the privacy of
            our customers and users. This privacy policy explains how we
            collect, use, and protect the personal information of those who use
            our Travel Solution Software.
          </p>

          <div style={bgg}>
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="mb-3">How We Use Your Information</h4>
                <p>We use your personal information to:</p>
                <ul className="lh-lg">
                  <li>
                    Provide you with travel solutions, including booking
                    flights, hotels, and transportations
                  </li>
                  <li>
                    Communicate with you about your travel plans and other
                    relevant information
                  </li>
                  <li>Improve our travel solutions and services</li>
                  <li>
                    Send you promotional offers and other marketing materials
                  </li>
                </ul>
                <p>
                  We may share your personal information with third-party
                  service providers who help us provide our travel solutions,
                  such as airlines, hotels, and car rental companies. We require
                  these service providers to maintain the confidentiality of
                  your information and only use it for the purposes for which we
                  have engaged them.
                </p>
              </div>
            </div>
          </div>
          <div style={bgg}>
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="mb-3">Information We Collect</h4>
                <p>
                  We may collect the following information when you use our
                  travel solutions software:
                </p>
                <ul className="lh-lg">
                  <li>
                    {" "}
                    Personal information such as your name, email address, phone
                    number, and billing information
                  </li>
                  <li>
                    {" "}
                    Information about your travel preferences, such as the
                    destinations you are interested in, your travel dates, and
                    the number of people in your party
                  </li>
                  <li>
                    {" "}
                    Information about your device and internet connection, such
                    as your IP address, operating system, and browser type
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div style={bgg}>
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="mb-3">Cookies and Similar Technologies</h4>
                <p className="lh-lg">
                  We use cookies and similar technologies to collect information
                  about your use of our travel solutions. This information may
                  include your IP address, device type, and browser type. We use
                  this information to improve our travel solutions and
                  personalize your experience.
                </p>
              </div>
            </div>
          </div>
          <div style={bgg}>
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="mb-3">Data Retention</h4>
                <p className="lh-lg">
                  We retain your personal information for as long as necessary
                  to provide you with our travel solutions and as required by
                  applicable law. We may also retain certain information for a
                  longer period of time if necessary for legal, tax, or
                  accounting purposes.
                </p>
              </div>
            </div>
          </div>
          <div style={bgg}>
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="mb-3">Security</h4>
                <p className="lh-lg">
                  We take reasonable steps to protect the personal information
                  we collect from unauthorized access, disclosure, alteration,
                  and destruction. However, no method of transmission over the
                  internet or electronic storage is completely secure.
                </p>
              </div>
            </div>
          </div>
          <div style={bgg}>
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="mb-3">Your Rights</h4>
                <p className="lh-lg">
                  You have the right to access, correct, and delete your
                  personal information. You may also object to the processing of
                  your personal information or request that we restrict the
                  processing of your personal information. To exercise these
                  rights, please contact us using the information provided
                  below.
                </p>
              </div>
            </div>
          </div>
          <div style={bgg}>
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="mb-3">Changes to this Privacy Policy</h4>
                <p className="lh-lg">
                  We may update this privacy policy from time to time. We will
                  notify you of any changes by posting the new privacy policy on
                  this page.
                </p>
              </div>
            </div>
          </div>
          <div style={bgg} className="mb-4">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="mb-3">Contact Us</h4>
                <p className="lh-lg">
                  If you have any questions about this privacy policy or our
                  practices, please contact us at info@apeitsolutions.com.
                   {/* or
                  call on 01217987215. */}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="decoration_item shape_image_1">
          <img src={shape1} alt=" Shape" />
        </div>
        <div className="decoration_item shape_image_2">
          <img src={shape2} alt=" Shape Angle" />
        </div>
      </section>
    </main>
  );
}

export default Privacypolicy;
